import { render } from "./pop-up.vue?vue&type=template&id=60e3ef66&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"

import "./pop-up.vue?vue&type=style&index=0&id=60e3ef66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-60e3ef66"

export default script